export default __webpack_public_path__ + "static/media/signIn.bc498448.png";